import { handleActions } from 'redux-actions';
import * as Actions from '../actions/campEntryActions';

const app = handleActions({
  [Actions.setCampId]: (state, action) => ({
    ...state,
    campId: action.payload,
  }),
  [Actions.setPlans]: (state, action) => ({
    ...state,
    plans: action.payload,
  }),
  [Actions.setStayPlans]: (state, action) => ({
    ...state,
    stayPlans: action.payload,
  }),
  [Actions.setPlanStayplanMeetingTimes]: (state, action) => ({
    ...state,
    planStayplanMeetingTimes: action.payload,
  }),
  [Actions.setCourses]: (state, action) => ({
    ...state,
    courses: action.payload,
  }),
  [Actions.setPayments]: (state, action) => ({
    ...state,
    payments: action.payload,
  }),
  [Actions.setRentals]: (state, action) => ({
    ...state,
    rentals: action.payload,
  }),
  [Actions.setPcTypes]: (state, action) => ({
    ...state,
    pcTypes: action.payload,
  }),
  [Actions.setPrices]: (state, action) => {
    let couponError = '';
    if (action.payload !== undefined && action.payload.couponErrors !== undefined && !$.isEmptyObject(action.payload.couponErrors)) {
      [couponError] = action.payload.couponErrors[Object.keys(action.payload.couponErrors)[0]];
    }
    return {
      ...state,
      prices: action.payload,
      couponError,
    };
  },
  [Actions.setSchoolNames]: (state, action) => ({
    ...state,
    schoolNames: action.payload,
  }),
  [Actions.setLoadingSchoolNames]: (state, action) => ({
    ...state,
    loadingSchoolNames: action.payload,
  }),
  [Actions.setPeymentId]: (state, action) => ({
    ...state,
    paymentId: action.payload,
  }),
}, {
  campId: 0,
  plans: [],
  stayPlans: [],
  planStayplanMeetingTimes: [],
  courses: [],
  payments: [],
  rentals: [],
  pcTypes: [],
  prices: {},
  schoolNames: [],
  loadingSchoolNames: false,
  couponError: '',
  paymentId: 0,
});

export default app;
